import { useContracts } from '../../../contexts/ContractContext';

import { useState, useEffect } from 'react';
import { Contract } from '../../../types/contract';

export const useContractData = (contractId: string) => {
  const { contracts, loading, deleteContract: deleteFromContext } = useContracts();
  const [contract, setContract] = useState<Contract | null>(null);

  useEffect(() => {
    if (contractId && contracts.length > 0) {
      const foundContract = contracts.find(c => c.id === contractId);
      setContract(foundContract || null);
    }
  }, [contractId, contracts]);

  const deleteContract = (contractId: string) => {
    deleteFromContext(contractId);
  };

  return { contract, setContract, loading, deleteContract };
};
